import { render, staticRenderFns } from "./DroitProfils.vue?vue&type=template&id=3d9cc2d2&"
import script from "./DroitProfils.vue?vue&type=script&lang=ts&"
export * from "./DroitProfils.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports